export default "__VITE_ASSET__Dja67kLe__"